
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoHd4Grid extends Serenity.EntityGrid<PsAdvPromoHd4Row, any> {
        protected getColumnsKey() { return PsAdvPromoHd4Columns.columnsKey; }
        protected getDialogType() { return PsAdvPromoHd4Dialog; }
        protected getIdProperty() { return PsAdvPromoHd4Row.idProperty; }
        protected getInsertPermission() { return PsAdvPromoHd4Row.insertPermission; }
        protected getLocalTextPrefix() { return PsAdvPromoHd4Row.localTextPrefix; }
        protected getService() { return PsAdvPromoHd4Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );
            return buttons;

        }
    }
}